import { Box } from "@radix-ui/themes";
import Stack from "@/components/ui/stack";
import { Outlet } from "@tanstack/react-router";

export default function CenteredLayout() {
  return (
    <Box className="min-h-screen bg-[#F2F4F7]">
      <Stack
        gap="32px"
        className="z-10 w-full min-h-screen px-[112px] flex items-center justify-center"
      >
        <Outlet />
      </Stack>
    </Box>
  );
}
